var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,17.5l-6.8-6.8l-1.4,1.4l8.5,8.5l0.7,0.7l0.7-0.7l8.5-8.5l-1.4-1.4L16,18.4L15,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomSimple);
export default __webpack_public_path__ + "static/media/arrow-bottom-simple.c6fc8566f4521bd0b6a91abf905adc2e.svg";
export { ForwardRef as ReactComponent };